<template>
  <div class="profile-container container">
    <div class="profile-portrait">
      <div class="profile-portrait-container">
      <figure>
        <img src="../../assets/images/jacklyn_siu_yuin_tan.jpg" alt="Jacklyn Siu Yuin Tan">
          </figure>
         <div class="finger-print"><img src="@/assets/images/fingerprints/fingerprint-one.svg" alt=""></div>
      </div>
    </div>
    <div class="profile-statement">

      <h2>Jacklyn Siu Yuin Tan</h2>
      <p class="job-title">Student</p>

        <p class="profile-statement-interviewer">Tell us a little bit about yourself </p>

        <p>I am a mature student who decided to pursue Physiotherapy in the UK after being a teacher in Singapore for 9.5 years. I wanted to experience a cross-cultural experience as I came to the UK to pursue a different career learning path.</p>

        <p class="profile-statement-interviewer">Why Man Met University?</p>

        <p>Man Met University has been a university which has a good wide range of diverse students, and I felt that studying here would be a good cultural exchange.</p>

        <p class="profile-statement-interviewer">What is something that you love about your culture or heritage? </p>

        <p>What I love about my culture and heritage is the cooking and fusion, as well as the different festivals that come with the history and meaning.</p>

        <p class="profile-statement-interviewer">What does it look like to bring your whole self to your education?</p>
          
          <p>I think it has been challenging to look at situations from different perspectives and learn how to adapt to what might be necessary to make things better in terms of helping patients and working in a cross-cultural environment.</p>

        <p class="profile-statement-interviewer">How do you think MMU can best celebrate their Black, Asian, and Ethnic Minority staff and students? </p>

        <p>MMU can best celebrate the black, Asian and ethnic minority staff by having festivals and workshops that are conducted by ethnic groups that come from outside of UK and teach and share skills.</p>

        <p class="profile-statement-interviewer">What are you most proud of?</p>

        <p>I am proud of my own heritage and having the courage to venture abroad to learn more about myself and others cross-culturally.</p>

    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>

  // .profile-container {
  // flex-direction: row-reverse;
  // }

  .profile-portrait-container {
    justify-content: flex-start;
  }

</style>